module.exports = __webpack_public_path__ + "media/promo/courses/images/structm-c0f27064bfff0dffe0fe38f84e804e6f.jpg";